import React from "react";

const IconCampaigns = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 95 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.87252 54.3523C5.43252 53.7023 4.55252 53.5323 3.96252 54.0523C-0.417476 57.9223 -1.32748 64.5823 2.04252 69.5523C5.42252 74.5223 11.9025 76.0723 17.0725 73.3523C17.7625 72.9923 17.9225 72.0923 17.4825 71.4423L5.87252 54.3423V54.3523Z" />
      <path d="M62.5025 55.0623C62.7025 54.9723 62.9025 54.8823 63.1025 54.7823C68.0625 53.7723 70.5925 47.9623 67.6325 43.7423L63.4525 37.7823C67.0425 34.4723 67.7325 28.9323 64.8825 24.8023C62.0025 20.6323 56.5025 19.3323 52.1125 21.6023L47.8525 15.5223C44.9825 11.4323 38.9225 11.6823 36.1625 15.6623C36.0225 15.8023 35.8925 15.9523 35.7625 16.1023L11.2425 45.5723C9.08252 48.1623 8.93252 51.8723 10.8725 54.6323L19.4025 66.8123C21.4225 69.6923 25.1725 70.7723 28.4125 69.4123L29.3325 69.0223L39.7825 84.5923C42.2025 88.2023 47.1025 89.1623 50.7125 86.7423C54.3225 84.3223 55.2825 79.4223 52.8625 75.8123L44.1225 62.7923L62.5025 55.0623Z" />
      <path
        d="M59.9525 12.3123C59.0425 13.6023 59.3525 15.3923 60.6425 16.3023C61.9325 17.2123 63.7225 16.9023 64.6325 15.6123L72.4525 4.51227C73.3625 3.22227 73.0525 1.43227 71.7625 0.522268C70.4725 -0.387732 68.6825 -0.0777321 67.7725 1.21227L59.9525 12.3123Z"
        className="fill-secondary-on-hover-target"
      />
      <path
        d="M94.2925 12.3723C95.0625 13.7523 94.5625 15.5023 93.1825 16.2723L73.7925 27.0823C72.4125 27.8523 70.6625 27.3523 69.8925 25.9723C69.1225 24.5923 69.6225 22.8423 71.0025 22.0723L90.3925 11.2623C91.7725 10.4923 93.5225 10.9923 94.2925 12.3723Z"
        className="fill-secondary-on-hover-target"
      />
      <path
        d="M92.3525 32.8623C92.5825 34.4223 91.5025 35.8823 89.9425 36.1123L75.9625 38.1923C74.4025 38.4223 72.9425 37.3423 72.7125 35.7823C72.4825 34.2223 73.5625 32.7623 75.1225 32.5323L89.1025 30.4523C90.6625 30.2223 92.1225 31.3023 92.3525 32.8623Z"
        className="fill-secondary-on-hover-target"
      />
    </svg>
  );
};

export default IconCampaigns;
